export default __webpack_public_path__ + "static/media/ic_hidde_Nav.790d59fd.svg";